export default ($resource) => {
    const url = `${SEED_CORE.ENV.API_URL}course/occurrence-training-time/:id`;
    return $resource(url, null, {
        update: {
            method: 'PUT',
            url
        },
        confirm: {
            method: 'GET',
            url: `${url}/confirm`
        },
        removeConfirmation: {
            method: 'GET',
            url: `${url}/remove-confirmation`
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/TrainingTime/index.js